// Radix Select forbids an empty-string item value, so every "no project"
// option carries this sentinel and maps back to null on the way out.
export const NO_PROJECT_VALUE = "none"
